import axios from 'axios';
import { useQuery } from 'react-query';
import API from '../../../../utils/API';

const useFetchTwoFactorAuthSetUpData = () => useQuery(
    ['useFetchTwoFactorAuthSetUpData'],
    async () => {
        const response = await axios.get(`${API.TWO_FACTOR_AUTH.GET_SETUP_DATA}`);
        return response;
    },
    {
        cacheTime: 0,
        staleTime: 0,
    },
);

export default useFetchTwoFactorAuthSetUpData;
